module.exports = __webpack_public_path__ + "static/media/justify-lg-9.912a183f.jpg";